<!-- eslint-disable-next-line @angular-eslint/template/interactive-supports-focus -- it is focusable -->
<div
  class="switch"
  (click)="onValueChange.emit(!value)"
  (keydown.enter)="$event.stopPropagation(); onValueChange.emit(!value)"
>
  <input [ngModel]="value" [id]="id" class="switch__input" type="checkbox" />
  <span class="switch__slider"></span>
</div>
